/**
 * Abstract Element Class
 */
qtee.customDesign.AbstractElement = class {

	constructor (element, opts) {

		// Raphael element. We use name 'rel' to avoid expression like that 'el.element.element' inside canvas
		this.rel = element;
		this._opts = opts;
		this.zIndex = 0;
		this._type = undefined;
		this._sid = undefined; // server id of model
		this._cid = undefined; // client id of model

	}

	get id () {

		return this.rel.id;

	}

	set id (id) {

		throw 'id is readonly property';

	}

	get sid () {

		return this._sid;

	}

	set sid (sid) {

		this._sid = sid;

	}

	get cid () {

		return this._cid;

	}

	set cid (cid) {

		this._cid = cid;

	}

	get freeTransform () {

		return this.rel.freeTransform;

	}

	set freeTransform (ft) {

		throw 'freeTransform is readonly property';

	}

	get type () {

		return this._type;

	}

	set type (type) {

		throw 'type is readonly property';

	}

	/** Remove element from paper */
	remove () {

		this.rel.freeTransform && this.rel.freeTransform.unplug();
		this.rel.remove();

	}

	/** Return true if element was removed from paper */
	isRemoved () {

		if (this.rel.length > 0) {

			return this.rel[0].removed;

		}

		return this.rel.removed;

	}

	showBoundingBox () {

		this.rel.freeTransform.bbox.show().toFront();

		this.rel.freeTransform.handles.x.line.show().toFront();
		this.rel.freeTransform.handles.x.disc.show().toFront();
		this.rel.freeTransform.handles.y.line.show().toFront();
		this.rel.freeTransform.handles.y.disc.show().toFront();

		this.rel.freeTransform.handles.bbox[0].element.show().toFront();
		this.rel.freeTransform.handles.bbox[1].element.show().toFront();
		this.rel.freeTransform.handles.bbox[2].element.show().toFront();
		this.rel.freeTransform.handles.bbox[3].element.show().toFront();

		return this;

	}

	hideBoundingBox () {

		this.rel.freeTransform.bbox.hide();

		this.rel.freeTransform.handles.x.line.hide();
		this.rel.freeTransform.handles.x.disc.hide();
		this.rel.freeTransform.handles.y.line.hide();
		this.rel.freeTransform.handles.y.disc.hide();

		this.rel.freeTransform.handles.bbox[0].element.hide();
		this.rel.freeTransform.handles.bbox[1].element.hide();
		this.rel.freeTransform.handles.bbox[2].element.hide();
		this.rel.freeTransform.handles.bbox[3].element.hide();

		return this;

	}

	resetBoundingBox () {

		// KLUDGE: since Free Transform doesn't support reset bbox function so we reinit it
		// save callback before unplug
		const { callback } = this.rel.freeTransform;

		this.rel.freeTransform.unplug();

		// reinit
		this.rel.paper.freeTransform(this.rel, this._opts.freeTransform, callback);

		return this;

	}

	isNew () {

		return undefined == this.sid;

	}

	getX () {

		return this.rel.freeTransform.attrs.center.x + this.rel.freeTransform.attrs.translate.x;

	}

	setX (x) {

		this.rel.freeTransform.attrs.translate.x = x - this.rel.freeTransform.attrs.center.x;
		return this;

	}

	getY () {

		return this.rel.freeTransform.attrs.center.y + this.rel.freeTransform.attrs.translate.y;

	}

	setY (y) {

		this.rel.freeTransform.attrs.translate.y = y - this.rel.freeTransform.attrs.center.y;
		return this;

	}

	getR () {

		return this.rel.freeTransform.attrs.rotate >= 0
			? this.rel.freeTransform.attrs.rotate
			: 360 + this.rel.freeTransform.attrs.rotate;

	}

	setR (r) {

		this.rel.freeTransform.attrs.rotate = r < 180 ? r : r - 360;
		return this;

	}

	setS (s) {

		this.rel.freeTransform.attrs.scale = { x: s, y: s };
		return this;

	}

	getS () {

		return this.rel.freeTransform.attrs.scale.x;

	}

	apply () {

		this.rel.freeTransform.apply();
		return this;

	}

	saveToModel () {

		throw 'This method should be overwritten in a child class';

	}

	loadFromModel (model) {

		throw 'This method should be overwritten in a child class';

	}

	ready () {

		throw 'This method should be overwritten in a child class';

	}

};
